import {
  SET_LOCATION,
  SET_PLACE,
  SEARCH_BY_PLACE,
  SELECT_RESTAURANT,
  SET_TABLE_NUMBER,
  SHOW_RESULTS,
  HIDE_RESULTS,
} from './actions';

export default (dispatch) => ({
  setLocation: (location) => dispatch({ type: SET_LOCATION, location }),
  setPlace: ({ target: { value: place } }) => dispatch({ type: SET_PLACE, place }),
  searchByPlace: (place) => dispatch({ type: SEARCH_BY_PLACE, place }),
  selectRestaurant: (event, selectedRestaurant) =>
    dispatch({ type: SELECT_RESTAURANT, selectedRestaurant }),
  setTableNumber: ({ target: { value: tableNumber } }) =>
    dispatch({ type: SET_TABLE_NUMBER, tableNumber }),
  showResults: () => dispatch({ type: SHOW_RESULTS }),
  hideResults: () => dispatch({ type: HIDE_RESULTS }),
});
